export default __webpack_public_path__ + "static/media/Poker.0cc5de68.svg";